
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_19jr7_3",
  "button": "awsui_button_fvjdu_19jr7_20",
  "dots": "awsui_dots_fvjdu_19jr7_21",
  "button-disabled": "awsui_button-disabled_fvjdu_19jr7_43",
  "arrow": "awsui_arrow_fvjdu_19jr7_48",
  "page-number": "awsui_page-number_fvjdu_19jr7_58",
  "button-current": "awsui_button-current_fvjdu_19jr7_64",
  "page-item": "awsui_page-item_fvjdu_19jr7_79",
  "root-disabled": "awsui_root-disabled_fvjdu_19jr7_95"
};
  